import pic1 from './images/pic1.png'
import pic2 from './images/pic2.png'
import pic3 from './images/pic3.png'
import pic4 from './images/pic4.png'
import pic5 from './images/pic5.png'
import pic6 from './images/pic6.png'
import pic7 from './images/pic7.png'
import pic8 from './images/pic8.png'
import pic9 from './images/pic9.png'

export const CarouselData=[
    { 
      image:"https://i.ytimg.com/vi/ANpDikx-xc0/maxresdefault.jpg",
      thumb:pic9,
      title:"Achour 10",
      rate:"9",  
    },
    {   image:"https://img.over-blog-kiwi.com/3/14/17/67/20190511/ob_9c48b6_21.jpg",
        thumb:pic8,
        title:"Dakyous && Makyous",
        rate:"8.5",    
    },
    {   image:"https://cdn.liberte-algerie.com/images/article/thumbs/d-linoubliable-inspecteur-tahar-d6281.jpg",
        thumb:pic7,
        title:"Inspecteur tahar",
        rate:"9.5",      
    },
    {   image:"https://dia-algerie.com/wp-content/uploads/2019/04/corso.jpg",
        thumb:pic6,
        title:"Rais corso",
        rate:"1.5",      
    },

    {   image:"https://i.ytimg.com/vi/bdDoVmOc8jU/maxresdefault.jpg",
        thumb:pic5,
        title:"Bou balto (lah ghaleb n3amero bih el vide) ",
        rate:"0.5",        
    },
    { 
        image:"https://i.ytimg.com/vi/ANpDikx-xc0/maxresdefault.jpg",
        thumb:pic9,
        title:"Achour 10",
        rate:"9",  
    },
    {   image:"https://img.over-blog-kiwi.com/3/14/17/67/20190511/ob_9c48b6_21.jpg",
          thumb:pic8,
          title:"Dakyous && Makyous",
          rate:"8.5",    
    },
]

export const today=[
    { image:pic1,
    },
    { image:pic4,
    },
    { image:pic3,
    },
    { image:pic2,
    },
    { image:pic1,
    },
]

export const upnext=[
    { image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQYuHJ-Tfbor1Q0KFYVNH3BgWGrqvBUmWhEVSkdxddnnJvgHzAYTLvNqc8MfbstwO6NImQ&usqp=CAU",
      title:"La Bataille d'Alger"     
    },
    { image:
        "https://upload.wikimedia.org/wikipedia/commons/d/d2/Chronique_des_annees_de_braise.jpg",
        title:"Chronique des annees de braise"
    },
    {image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSt4xd-9u_pWo-HIivCMu8c4Wgv_drWyllG2Sc2nSRpuEvVhl4ABS1UiibYU_GrFJygasw&usqp=CAU",
        title:"Un rêve algérien"
    },
]